import { IApplicationState } from '../../types/redux/store';

export const openedChatIdSelector = (state: IApplicationState): string | null => {
  return state.consultantCianChat.chatId;
};
